module.exports = "/fonts/Roboto-MediumItalic.ttf?ebbeb79e6b0c7047a04879e32acc0aa7";